
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"18.574","y":".957","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M3.052 36.399c0 .459-.283.763-.848.912a.408.408 0 00.096.096.96.96 0 00.72.32c.139.01.283-.053.432-.192.544-.544 1.099-2.15 1.664-4.816.299-1.387.677-3.403 1.136-6.048A228.532 228.532 0 019.836 9.599c.235-.896.41-1.563.528-2 .128-.437.315-1.008.56-1.712.245-.715.501-1.285.768-1.712.277-.437.581-.773.912-1.008.352-.256.693-.384 1.024-.384.544 0 .981.176 1.312.528.33.352.512.79.544 1.312 0 .299-.08.539-.24.72-.16.181-.384.272-.672.272a.85.85 0 01-.624-.256.869.869 0 01-.256-.64c0-.459.283-.763.848-.912l-.048-.064a1.95 1.95 0 00-.256-.208.932.932 0 00-.528-.16.275.275 0 00-.112.016c-.341.096-.688.63-1.04 1.6-.352.96-.741 2.523-1.168 4.688a114.62 114.62 0 00-.88 4.816 245.054 245.054 0 01-3.584 17.008c-.341 1.355-.63 2.39-.864 3.104-.395 1.195-.827 2.101-1.296 2.72-.48.672-1.061 1.008-1.744 1.008-.48 0-.89-.181-1.232-.544a2.01 2.01 0 01-.528-1.312c0-.299.08-.539.24-.72.16-.17.384-.256.672-.256.245 0 .453.085.624.256.17.17.256.384.256.64z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"8.08","y":"37.043","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"30.574","y":"17.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    